(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-page"]) return;
  try {
    
  (() => {
    const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().replace(/[^\p{L}\p{N}]/gu, '');
    function initialize(scope) {
      scope.querySelectorAll('[data-ec-brand-directory]').forEach(root => {
        if (root.dataset.initialized) return;
        const source = root.querySelector('[data-ec-brand-source]');
        const candidates = source.querySelectorAll('li a[href*="/collections/"], a[href$="/collections/acqua-di-parma"]');
        const seen = new Set();
        const brands = Array.from(candidates).filter(link => {
          const key = link.href.split('?')[0].replace(/\/$/, '');
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        }).map(link => ({ name: link.textContent.trim(), href: link.getAttribute('href') }));
        if (!brands.length) return;
        const collator = new Intl.Collator(document.documentElement.lang || 'en', { sensitivity: 'base', numeric: true });
        brands.sort((a, b) => collator.compare(a.name, b.name));
        const tools = root.querySelector('[data-ec-brand-tools]');
        const alphabet = root.querySelector('[data-ec-brand-alphabet]');
        const index = root.querySelector('[data-ec-brand-index]');
        const search = root.querySelector('[data-ec-brand-search]');
        const all = root.querySelector('[data-ec-brand-all]');
        let selectedLetter = '';
        index.id = search.id + '-results';
        all.setAttribute('aria-controls', index.id);
        const intro = document.createElement('div');
        intro.className = 'ec-brand-intro prose';
        for (const child of source.children) {
          if (/^H[1-6]$/.test(child.tagName)) break;
          if (child.tagName === 'P') intro.append(child.cloneNode(true));
        }
        if (intro.childElementCount) tools.before(intro);
        const groups = new Map();
        brands.forEach(brand => {
          const letter = /^\d/.test(brand.name) ? '0–9' : brand.name[0].toLocaleUpperCase();
          if (!groups.has(letter)) {
            const group = document.createElement('section');
            group.className = 'ec-brand-group';
            group.id = root.querySelector('input').id + '-group-' + groups.size;
            const heading = document.createElement('h2');
            heading.className = 'h5';
            heading.textContent = letter;
            const list = document.createElement('ul');
            group.append(heading, list);
            index.append(group);
            const filter = document.createElement('button');
            filter.type = 'button';
            filter.textContent = letter;
            filter.setAttribute('aria-pressed', 'false');
            filter.setAttribute('aria-controls', index.id);
            filter.addEventListener('click', () => {
              selectedLetter = letter;
              search.value = '';
              updateResults();
            });
            alphabet.append(filter);
            groups.set(letter, { group, list, filter, entries: [] });
          }
          const group = groups.get(letter);
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = brand.href;
          link.textContent = brand.name;
          item.append(link);
          group.list.append(item);
          group.entries.push({ item, name: normalize(brand.name) });
        });
        const inStore = source.querySelector('a[href$="/collections/acqua-di-parma"]');
        const inStoreParagraph = inStore?.closest('p');
        let inStoreNote;
        if (inStoreParagraph) {
          inStoreNote = inStoreParagraph.cloneNode(true);
          inStoreNote.className = 'ec-brand-note prose';
          root.append(inStoreNote);
        }
        function updateResults() {
          const query = normalize(search.value);
          let visibleCount = 0;
          groups.forEach((group, letter) => {
            let matches = 0;
            group.entries.forEach(entry => {
              const visible = (!selectedLetter || selectedLetter === letter) && entry.name.includes(query);
              entry.item.hidden = !visible;
              if (visible) matches += 1;
            });
            group.group.hidden = matches === 0;
            group.filter.setAttribute('aria-pressed', String(selectedLetter === letter));
            visibleCount += matches;
          });
          root.querySelector('[data-ec-brand-empty]').hidden = visibleCount > 0;
          if (inStoreNote) inStoreNote.hidden = Boolean(selectedLetter && selectedLetter !== 'A') || !normalize(inStore.textContent).includes(query);
          all.setAttribute('aria-pressed', String(!selectedLetter));
          index.classList.toggle('is-letter-filtered', Boolean(selectedLetter));
        }
        all.addEventListener('click', () => {
          selectedLetter = '';
          search.value = '';
          updateResults();
        });
        search.addEventListener('input', () => {
          selectedLetter = '';
          updateResults();
        });
        root.dataset.initialized = 'true';
        source.hidden = true;
        tools.hidden = false;
      });
    }
    initialize(document);
    document.addEventListener('shopify:section:load', event => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-testimonial-direction]');
    if (!control) return;

    const section = control.closest('.shopify-section--testimonials');
    const carousel = section ? section.querySelector('testimonial-carousel') : null;
    if (!carousel) return;

    const slides = Array.from(carousel.querySelectorAll('.testimonial-item'));
    if (slides.length < 2) return;

    const carouselLeft = carousel.getBoundingClientRect().left;
    let currentIndex = 0;
    let closestDistance = Number.POSITIVE_INFINITY;

    slides.forEach((slide, index) => {
      const distance = Math.abs(slide.getBoundingClientRect().left - carouselLeft);

      if (distance < closestDistance) {
        closestDistance = distance;
        currentIndex = index;
      }
    });

    const direction = control.dataset.testimonialDirection === 'previous' ? -1 : 1;
    const nextIndex = (currentIndex + direction + slides.length) % slides.length;
    const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

    slides[nextIndex].scrollIntoView({ behavior, block: 'nearest', inline: 'start' });
  });

  } catch(e) { console.error(e); }
})();
})();
